import Hosts from '../../../Hosts';

//const object_type = 'Credits'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/entities/profiles`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/entities/profiles/${companycode}`

const base_endpoint = '/entity_perfil'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    name: '',
    settings: {
        companycode: '',
        name: '',
        forms: {},
        menu: []
    }
}

const data_inputs = {
    externa: {
        coletiva:  ["sector", "dimensao", "grau_risco", "fidelidade", "satisfacao", "sugestao", "observacao"],
        individual: ["modalidade", "numero_interno", "admissao", "numero_atleta", "entrada_associacao", "validade_contrato", "seguro_acidentes", "data_exames_medicos", "tipo_associado", "valor_quotas", "detalhes"]
    }
}

export {
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    data_inputs,
    api_list_route
}